// Node
const $ = require('jquery');
// require('owl.carousel/dist/owl.carousel');
import { tns } from 'tiny-slider/src/tiny-slider';

// Custom
import { handleMiniSliderOpen, updateCounterText } from 'new_design/common/sliders';

// const sliderInit = function () {
//   let sightSlider = $('.sight-slider');
//
//   sightSlider.each(function () {
//     let sightSlider = $(this);
//
//     if (sightSlider.hasClass('owl-loaded')) {
//       return;
//     }
//
//     sightSlider.owlCarousel({
//       loop: true,
//       margin: 30,
//       nav: false,
//       dots: false,
//       responsive: {
//         0: {
//           items: 1
//         },
//         992: {
//           items: 4
//         }
//       }
//     });
//
//     let next = $('.sight-slider__next'),
//       prev = $('.sight-slider__prev');
//
//     next.on('click', function () {
//       sightSlider.trigger('next.owl.carousel');
//     });
//     prev.on('click', function () {
//       sightSlider.trigger('prev.owl.carousel', [300]);
//     });
//   });
// };

const popupSliderTnsInit = function () {
  let $sliderWraps = $('.slider-tns__wrap');

  $sliderWraps.each(function () {
    let $wrap = $(this);
    let $slider = $wrap.find('.slider-tns');
    let $controls = $wrap.find('.slider-tns__arrows');
    let $counter = $wrap.find('.slider-tns__counter');
    let $thumbnails = $wrap.find('.slider-tns__thumbnails');
    let $thumbItems = $thumbnails.find('.slider-tns__thumbnails-item');
    let lazyloadEnabled = !!$slider.hasClass('slider-tns_lazy');

    if (this.classList.contains('tns-initialised')) return;

    let sliderTns = tns({
      container: $slider[0],
      mode: 'gallery',
      items: 1,
      center: true,
      loop: false,
      nav: false,
      rewind: true,
      controlsContainer: $controls[0],
      arrowKeys: true,
      autoHeight: true,
      lazyload: lazyloadEnabled,
      onInit: (info) => updateCounterText(info, $counter),
    });

    if (!sliderTns) return; // на случай, если изображений нет

    let thumbSlider = null;

    if ($thumbItems.length) {
      thumbSlider = tns({
        container: $thumbnails[0],
        items: 1,
        fixedWidth: 100,
        gutter: 10,
        loop: false,
        nav: false,
        controls: false,
        mouseDrag: true,
        slideBy: 1,
        edgePadding: 70,
        axis: 'horizontal',
      });

      $thumbItems.each(function (idx) {
        $(this).on('click', function () {
          sliderTns.goTo(idx);
        });
      });
    }

    const computeThumbTarget = (activeIndex) => {
      const info = thumbSlider.getInfo();

      const wrapper = info.container.parentElement;
      const slides = [...info.slideItems];

      const activeSlide = slides[activeIndex];
      if (!activeSlide) return null;

      const wrapperWidth = wrapper.clientWidth;
      const activeCenter = activeSlide.offsetLeft + activeSlide.offsetWidth / 2;

      const targetLeft = activeCenter - wrapperWidth / 2;

      const maxScroll = info.container.scrollWidth - wrapperWidth;

      const clampedLeft = Math.max(0, Math.min(targetLeft, maxScroll));

      let targetIndex = 0;

      for (let i = 0; i < slides.length; i++) {
        if (slides[i].offsetLeft >= clampedLeft) {
          targetIndex = i;
          break;
        }
      }

      if (targetIndex === info.index) {
        return null;
      }

      return targetIndex;
    };

    const setActiveThumb = (index) => {
      $thumbItems.removeClass('tns-nav-active').eq(index).addClass('tns-nav-active');
      if (!thumbSlider) return;

      const target = computeThumbTarget(index);
      if (target !== null) {
        thumbSlider.goTo(target);
      }
    };

    sliderTns.events.on('indexChanged', (info) => {
      updateCounterText(info, $counter);
      setActiveThumb(info.index);
    });

    setActiveThumb(sliderTns.getInfo().index || 0);

    const $popup = $wrap.closest('.popup');
    const isWheelEnabled =
      $popup.hasClass('photo-popup_camp') ||
      $popup.hasClass('photo-popup_reviews') ||
      $popup.hasClass('photo-popup_reviews_item');

    if (isWheelEnabled) {
      let wheelLocked = false;
      const wheelCooldown = 1000;

      $wrap[0].addEventListener(
        'wheel',
        function (e) {
          e.preventDefault();

          if (wheelLocked) return;

          const delta = e.deltaY !== 0 ? e.deltaY : e.deltaX;
          if (Math.abs(delta) < 1) return;

          wheelLocked = true;

          if (delta > 0) {
            sliderTns.goTo('next');
          } else {
            sliderTns.goTo('prev');
          }

          setTimeout(() => {
            wheelLocked = false;
          }, wheelCooldown);
        },
        { passive: false }
      );
    }

    $wrap.closest('.popup').on('popupClosed', () => {
      if (sliderTns.getInfo().displayIndex > 1) {
        setTimeout(() => sliderTns.goTo('first'), 500);
      }
    });

    handleMiniSliderOpen($slider, sliderTns);
    this.classList.add('tns-initialised');
  });
};

const campsSliderTnsInit = function () {
  const $sliderWraps = $('.nearby_camps-scroll__wrapper');
  $sliderWraps.each(function () {
    const $wrap = $(this);
    const $slider = $wrap.find('.nearby_camps-scroll');
    const $controls = $wrap.find('.nearby_camps__arrows');
    const $slides = parseInt($slider.attr('data-value'), 10) || 3;
    const $firstSlide = $slider.find('.review-slider-item').first();
    const firstSlideWidth = parseFloat($firstSlide.css('width')) + 2 || 290;
    const reviewSliderLength = $wrap.find('.review-slider').length;

    if (this.classList.contains('camps-tns-initialised')) return;

    const sliderTns = tns({
      container: $slider[0],
      items: $slides,
      slideCountNew: $slides,
      loop: !!reviewSliderLength,
      controlsContainer: $controls[0],
      nav: false,
      fixedWidth: firstSlideWidth,
      rewind: true,
      speed: 400,
      swipeAngle: false,
      preventScrollOnTouch: 'auto',
    });
    sliderTns.events.on('indexChanged', ({ index }) => {
      if (!reviewSliderLength) {
        $controls.find('.nearby_camps_arrow_wrapper-left').toggle(index !== 0);
        $controls.find('.nearby_camps_arrow_wrapper-right').toggle(index < 2);
      }
    });
    if (sliderTns.getInfo().slideCount < 4 && !reviewSliderLength) {
      $controls.find('.nearby_camps_arrow_wrapper-right').hide();
    }

    this.classList.add('camps-tns-initialised');

    const $elemWithLink = $wrap.find('.has-link');
    const link = $elemWithLink.data('link');

    if ($elemWithLink.length && link) {
      const $linkBlock = $elemWithLink.children().last();
      $linkBlock.on('click', function () {
        window.open(link, '_blank').focus();
      });
    }
  });
};
export {
  campsSliderTnsInit,
  // sliderInit,
  popupSliderTnsInit,
};
